import { render, staticRenderFns } from "./DutyAuth.vue?vue&type=template&id=87d5c3c6&scoped=true&"
import script from "./DutyAuth.vue?vue&type=script&lang=js&"
export * from "./DutyAuth.vue?vue&type=script&lang=js&"
import style0 from "./DutyAuth.vue?vue&type=style&index=0&id=87d5c3c6&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "87d5c3c6",
  null
  
)

export default component.exports